



















import { Component, Prop, Vue } from 'vue-property-decorator';
import PatternCell from './patternCell/patternCell.vue';

import * as def from '@/definitions'

@Component({
  components: {
      PatternCell
  },
})
export default class SelectPattern extends Vue 
{
    private selectedIndex : number = 0;

    private patternItems = [
        {pattern : 0, cornerNumber: 0}, // 矩形
        {pattern : 1, cornerNumber: 0}, // 円
        {pattern : 2, cornerNumber: 0}, // 三角形
        {pattern : 3, cornerNumber: 0}, // 星
        {pattern : 4, cornerNumber: 0}, // 矢印
        {pattern : 5, cornerNumber: 5}, // 五角形
        {pattern : 5, cornerNumber: 6}, // 六角形
        {pattern : 5, cornerNumber: 7}, // 七角形
        {pattern : 5, cornerNumber: 8}, // 八角形
    ]

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private cellStyle(item)
    {
        var index = this.patternItems.indexOf(item);
        var style = "position : absolute;"
        var col = index % 3;
        var row = Math.floor(index / 3);
        var left = 41 + 184 * col;
        var top = 24 + 184 * row;
        style += "left : " + left + "px;";
        style += "top : " + top + "px;";
        style += "padding-bottom : 24px;";
        return style;
    }

    private isSelected(item)
    {
        var index = this.patternItems.indexOf(item);
        return index == this.selectedIndex;
    }

    private onSelect(item)
    {
        var index = this.patternItems.indexOf(item);
        // 選択状態を変更
        this.selectedIndex = index;
    }

    private onOk()
    {
        var selectedItem = this.patternItems[this.selectedIndex];
        // 選択状態を通知
        this.$emit("select", selectedItem.pattern, selectedItem.cornerNumber);
        // 閉じる
        this.$emit("close");
    }
}
